/* eslint-disable no-restricted-globals */
import React from 'react';
import { Icon } from 'semantic-ui-react';
import * as Styles from 'pages/member/macros/Macros.styles';
import LoadingImage from 'assets/svg/loading.svg';
import { Link, useHistory } from 'react-router-dom';
import { H5, H6, P } from 'utils/resuable-css';
import { Base64 } from 'js-base64';

const ViewAllMacros = ({ getMacros, loadingMacros, getSubStatus, getDeparment }) => {
  let history = useHistory();
  return (
    <Styles.DraggableContainer id="alertParent">
      <div>
        <div id="alertChild">
          <Styles.TopBar>
            <Styles.Left>
              <Icon name="ticket alternate" color="black" />
              <H5>Client Macros</H5>
              {loadingMacros && <img src={LoadingImage} height={28} alt="loading" />}
            </Styles.Left>
          </Styles.TopBar>
        </div>
        <Styles.Content>
          <div>
            {getMacros?.macros?.map((val, i) => {
              const { macros_definitions: subStatusList } = getSubStatus || {};
              const subStatus = subStatusList?.find((status) => status.id === val.status);
              const { ticket_department_definitions: departmentList } = getDeparment || {};
              const department = departmentList?.find((dep) => dep.id === val.department);
              return (
                <Styles.Issue key={i} onClick={() => history.push(`/admin/kb/macros/${val.id}`)}>
                  <Styles.Container>
                    <Styles.First>
                      <Styles.UserNameLinks>
                        <H6>{val?.label} </H6>
                      </Styles.UserNameLinks>
                      {val?.department !== '' && (
                        <Styles.DeparmentName>
                          <P>{department?.title_en} </P>
                        </Styles.DeparmentName>
                      )}
                    </Styles.First>
                    <Styles.Second>
                      <div className="subject">
                        <Link to={`/admin/kb/macros/${val.id}`}>
                          <H6>{Base64.decode(val?.subject)}</H6>
                        </Link>
                      </div>
                      <Styles.IssueName
                        style={{ background: `#${subStatus?.color}`, color: `#${subStatus?.font_color}` }}
                      >
                        <P>{subStatus?.title_en} </P>
                      </Styles.IssueName>
                    </Styles.Second>
                    <Styles.Third>
                      <P>{val?.date_local_format_mdy} </P>
                      <Icon name="pencil" />
                    </Styles.Third>
                  </Styles.Container>
                </Styles.Issue>
              );
            })}
          </div>
        </Styles.Content>
      </div>
    </Styles.DraggableContainer>
  );
};
export default ViewAllMacros;
